import styled from "styled-components";

export const ContainerModal: any = styled.div`
  width: 100%;
  margin-top: 0;
  .container-table {
    width: 100%;
    overflow-y: auto;
    th.ant-table-cell {
      font-weight: bold;
      color: black;
    }
  }
  .container-1 {
    gap: 8px;
    width: 100%;
    display: flex;
    justify-content: space-between;
    .ant-btn {
      display: flex;
      align-items: center;
      border-radius: 10px;
    }
  }
  .year-resume {
    .ant-typography {
      font-size: 14px;
      margin: 0px;
      font-weight: 600;
    }
    justify-content: space-between;
    border-radius: 10px;
    margin: 16px 0;
    display: flex;
    padding: 20px 25px;
    background-color: #ededed;
    width: 100%;
  }
  .client-wallet-header-btns {
    display: flex;
    column-gap: 8px;
    align-items: center;
    .ant-btn {
      height: 32px;
      min-width: 32px;
      font-weight: 500;
      border-radius: 24px;
      border: 1px solid var(--ghost);
      &.filtro-aplicado {
        color: var(--ant-primary-color);
        border: 1px solid var(--ant-primary-color);
        background-color: var(--ant-primary-1);
      }
      svg {
        fill: none;
        width: 18px;
        height: 18px;
        stroke: var(--ant-primary-color);
        &.fill {
          path {
            stroke: var(--ant-primary-color);
          }
        }
      }
    }
  }

  @media only screen and (max-device-width: 812px) {
    margin-top: 0px;
    .container-1 {
      flex-direction: column;
      .client-wallet-header-btns {
        width: 100%;
        .ant-select {
          width: 35%;
        }
        .ant-select:first-of-type {
          width: calc(65% - 8px);
        }
        .ant-btn {
          width: calc(50% - 4px);
        }
      }
    }
  }
`;
